import { createFileRoute } from "@tanstack/react-router";
import Photography from "@/pages/Photography";
import { seoHead } from "@/lib/seo";
import { industriesQuery, projectsLeanQuery, safePrefetch } from "@/lib/publicQueries";

export const Route = createFileRoute("/foto")({
  loader: async ({ context }) => {
    await Promise.all([
      safePrefetch(context.queryClient, projectsLeanQuery({ publicOnly: true })),
      safePrefetch(context.queryClient, industriesQuery()),
    ]);
  },
  head: () =>
    seoHead({
      title: "Fotograf Mannheim: Business, Immobilien, Events | Clicks DMP",
      description:
        "Professionelle Fotografie in Mannheim und Rhein-Neckar: Business, Immobilien, Events, Produkte. Vor Ort bei Ihnen, Lieferung in 2 bis 3 Tagen.",
      path: "/foto",
    }),
  component: Photography,
});
